import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchProjectsIfNeeded } from 'data/actions/projects';

import ProjectFilters from 'components/organisms/projectFilters';

class projectFiltersContainer extends Component {
    componentDidMount() {
        this.props.fetchProjectsIfNeeded();
    }

    componentDidUpdate(prevProps, prevState) {}

    render() {
        return <ProjectFilters {...this.props} />;
    }
}

function getCategories(projects) {
    let allCategories = [];
    let filteredCategories = [];
    let sortedCategories = [];

    if (projects.length) {
        // Get all categories in listed projects
        allCategories = projects.map(item => {
            return item.fields.category.fields;
        });

        //PHANTOMJS doesnt support Set [...new Set(allCategories)];
        // Reduce to unique items
        filteredCategories = allCategories.filter(
            (x, i, a) => a.indexOf(x) === i
        );

        // Sort on orderDate field
        sortedCategories = filteredCategories.sort((a, b) => {
            return new Date(a.orderDate) - new Date(b.orderDate);
        });
    }

    return sortedCategories;
}

const mapStateToProps = (state, ownProps) => {
    let projects = state.projects.all;
    let categories = getCategories(projects);

    return {
        categories: categories,
        hasError: state.projects.hasError,
        hasLoaded: state.projects.hasLoaded,
        isLoading: state.projects.isLoading
    };
};

projectFiltersContainer = withRouter(
    connect(mapStateToProps, { fetchProjectsIfNeeded })(projectFiltersContainer)
);

export default projectFiltersContainer;



// WEBPACK FOOTER //
// ./src/data/containers/projectFilters.js